import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {
  @Input() public text: string;
  translatedText: string;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.translate.get(this.text).subscribe(translation => {
      this.translatedText = translation;
    });
  }
}
